import { Ability } from '@casl/ability'
import { getAbilitiesForRole } from '@/auth/rolePermissions'
import { initialAbility } from './config'

let existingAbility = null

try {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const role = userData && userData.user && userData.user.role
  existingAbility = getAbilitiesForRole(role)
} catch (error) {
  existingAbility = null
}

export default new Ability(
  existingAbility && existingAbility.length
    ? existingAbility
    : initialAbility
)
